<template>
  <div>
    <v-chip :class="`card-reader-insert-icon`" :color="cardReaderStatus.iconColor" @click="isDialog = true">
      <v-icon>{{ cardReaderStatus.icon }}</v-icon>
    </v-chip>
    <v-dialog v-model="isDialog" max-width="500" scrollable>
      <v-card>
        <v-card-title>{{ $t('customer.citizen_card_status') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="card-reader-box">
          <div class="status-box" v-if="cardReaderStatus">
            <v-icon :color="cardReaderStatus.color">{{ cardReaderStatus.icon }}</v-icon>
            <div v-html="cardReaderStatus.text"></div>
            <div class="note" v-if="cardReaderStatus.note" v-html="cardReaderStatus.note"></div>
            <div class="data" v-if="getReadData && getReadData.success && getReadData.data">
              <div>{{ $t('account.citizen_id') }} :</div>
              <div>{{ getReadData.data.cid }}</div>
              <div>{{ $t('account.full_name_th') }} :</div>
              <div>{{ getReadData.data.fullNameTH.fullName }}</div>
              <div>{{ $t('account.full_name_en') }} :</div>
              <div>{{ getReadData.data.fullNameEN.fullName }}</div>
              <div>{{ $t('account.gender') }} :</div>
              <div>{{ getReadData.data.gender }}</div>
              <div>{{ $t('account.date_of_birth') }} :</div>
              <div>{{ getReadData.data.dateOfBirth.format }}</div>
              <div>{{ $t('account.expire_date_card') }} :</div>
              <div>{{ getReadData.data.expireDate.format }}</div>
              <div>{{ $t('account.issue_date_card') }} :</div>
              <div>{{ getReadData.data.issueDate.format }}</div>
              <div>{{ $t('account.address') }} :</div>
              <div>{{ getReadData.data.address }}</div>
              <div>{{ $t('account.zipcode') }} :</div>
              <div>{{ getReadData.data.zipcode }}</div>
              <div class="image"><img v-if="getReadData.data.imageData"
                  :src="'data:image/png;base64,' + getReadData.data.imageData" /></div>
              <div class="image-text">{{ $t('image') }}</div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="detail-box">
            <a href="https://www.myket.in.th/cid-reader/" target="_blank" rel="noopener noreferrer">
              <v-icon color="info">mdi-book-open-variant</v-icon>
              <span>{{ $t('project.user_manual') }}</span>
            </a>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="isDialog = false">
            <v-icon left>mdi-window-close</v-icon>
            <div>{{ $t('close') }}</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardReaderInsert",
  computed: {
    ...mapGetters({
      getSocketConnected: "socket/getSocketConnected",
      getIsCardInserted: "socket/getIsCardInserted",
      getIsDeviceActivated: "socket/getIsDeviceActivated",
      getReadData: "socket/getReadData"
    }),
    cardReaderStatus() {
      let res = { text: '', icon: 'mdi-smart-card-reader', color: '', iconColor: '', note: '' }
      if (!this.getSocketConnected) {
        res.icon = 'mdi-laptop-off'
        res.color = ''
        res.text = this.$t('validate.card_reader_not_use')
        res.iconColor = ''
        res.note = this.$t('validate.not_install_card_reader_program_or_not_support_system')
      } else if (this.getSocketConnected && !this.getIsDeviceActivated) {
        res.icon = 'mdi-smart-card-reader'
        res.color = 'error'
        res.text = this.$t('validate.not_connect_citizen_card_reader')
        res.iconColor = 'error'
        res.note = ''
      } else if (this.getSocketConnected && this.getIsDeviceActivated && !this.getReadData) {
        res.icon = 'mdi-smart-card-reader'
        res.color = 'warning'
        res.text = this.$t('validate.not_insert_citizen_card')
        res.iconColor = 'warning'
        res.note = this.$t('validate.please_insert_citizen_card_to_read_data')
      } else if (this.getSocketConnected && this.getIsDeviceActivated && this.getReadData) {
        if (this.getReadData.success) {
          res.icon = 'mdi-card-account-details'
          res.color = 'success'
          res.text = `${this.$t('validate.read_citizen_card')} <b>${this.$t('success')}</b>`
          res.iconColor = 'success'
        } else {
          res.icon = 'mdi-smart-card-off'
          res.color = 'error'
          res.text = `${this.$t('validate.read_citizen_card')} <b>${this.$t('failed')}</b>`
          res.iconColor = 'error'
          res.note = this.$t('validate.error_read_citizen_card_check_card_again')
        }
      }
      return res
    }
  },
  watch: {
    getReadData: {
      handler(data) {
        if (data && data.success && data.data) this.readData(data.data)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      isDialog: false,
      isLoading: false,
    };
  },
  props: {},
  methods: {
    readData(data) {
      this.$emit("readed", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-reader-insert-icon {
  position: fixed;
  right: 5px;
  bottom: 40px;
  z-index: 3;
  opacity: 0.6;
}

.card-reader-insert-icon:hover {
  opacity: 1;
}

.card-reader-box {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;

  .status-box {
    margin-top: 15px;
    // border: 1px solid rgb(231, 231, 231);
    // border-radius: 10px;
    // max-width: 400px;
    width: 100%;
    max-width: 430px;
    // padding: 30px;
    text-align: center;
    font-size: 20px;

    .v-icon {
      font-size: 50px;
      margin-bottom: 15px;
    }

    .note {
      font-size: 15px;
      margin-top: 5px;
    }

    .data {
      font-size: 15px;
      margin-top: 15px;
      text-align: left;
      display: flex;
      flex-wrap: wrap;
      gap: 7px 5px;
      align-items: center;
      justify-content: center;

      div {
        width: calc(50% - 10px);
      }

      div:nth-child(even) {
        text-align: left;
      }

      div:nth-child(odd) {
        text-align: right;
        font-weight: 500;
      }

      div.image {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(241, 241, 241);
        border-radius: 10px;
        padding: 5px;

        img {
          width: 50%;
          max-width: 150px;
          height: auto;
        }
      }

      div.image-text {
        width: 100%;
        text-align: center;
      }
    }
  }

}

.detail-box {
  a {
    color: var(--v-info-base);
    text-decoration: underline;

    .v-icon {
      margin-right: 5px;
    }
  }
}
</style>
